import React, { HTMLAttributes, SFC } from 'react';
import { WithStyles, createStyles, withStyles } from '../styles';
import { cx } from '../utils';

const styles = createStyles<'root'>(theme => ({
  root: {
    backgroundColor: theme.color('background.paper'),
    borderRadius: 4,
    boxShadow: [
      `0 0 8px ${theme.color('grey', '100')}`,
      `1px 1px 2px ${theme.color('grey', '200')}`,
    ].join(','),
    display: 'flex',
    flexDirection: 'column',
    fontSize: 0,
    '& > *': {
      fontSize: '1rem',
    },
  },
}));

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  domRef?: (el: HTMLElement | null) => void;
}

type Props = WithStyles<CardProps, typeof styles>;

const Card: SFC<Props> = ({ className, classes, theme, domRef, ...rest }) => (
  <div className={cx(classes.root, className)} {...rest} ref={domRef} />
);

export default withStyles(styles)(Card);
